import React from "react";

const StatusPage = () => <pre>{'{"status":"ok"}'}</pre>;

export default StatusPage;
